import {
  Button,
  Col,
  Form,
  Icons,
  Input,
  List,
  Row,
  ShowButton,
  Space,
  Table,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import { CrudFilters, IResourceComponentsProps } from "@pankod/refine-core";
import { ButtonExport } from "components/buttonExport";
import useMediaScreen from "hooks/useMediaScreen";
import React from "react";
import { IRequest } from "types/request.interface";
import { ITransactionResponse } from "types/transaction.interface";
import { getOrderNumber } from "utils";

export const RequestList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, searchFormProps }: any = useTable<ITransactionResponse>({
    resource: "requests",
    initialPageSize: 100,
    onSearch: (params) => {
      const filters: CrudFilters = [];
      const input = params;
      filters.push({
        field: "search",
        operator: "in",
        value: input,
      });
      return filters;
    },
  });
  const pageSize = tableProps?.pagination?.pageSize;
  const current = tableProps?.pagination?.current;
  const { isMobile } = useMediaScreen();

  return (
    <List>
      <Row style={{ display: "block" }}>
        <Col>
          <Form layout="vertical" {...searchFormProps}>
            <Form.Item
              label="Search"
              name="search"
              style={{ width: isMobile ? "100%" : "50%" }}
              initialValue=""
            >
              <Input
                placeholder="Type, Content "
                prefix={<Icons.SearchOutlined />}
              />
            </Form.Item>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  Filter
                </Button>
              </Form.Item>
              <ButtonExport path="requests" />
            </div>
          </Form>
        </Col>
        <Col>
          <Table
            {...tableProps}
            pagination={{
              ...tableProps?.pagination,
              showSizeChanger: true,
            }}
            rowKey="id"
          >
            <Table.Column
              dataIndex="_id"
              key="_id"
              title="Index"
              render={(value, item, index) => (
                <TextField value={getOrderNumber(current, pageSize, index)} />
              )}
            />
            <Table.Column
              dataIndex="type"
              key="type"
              title="Type"
              render={(value) => <TextField value={value} />}
              sorter
            />
            <Table.Column
              dataIndex="content"
              key="content"
              title="Content"
              render={(value) => <TextField value={value} />}
              sorter
            />
            <Table.Column
              dataIndex="track"
              key="track"
              title="Track Name"
              render={(value) => <TextField value={value?.title} />}
              sorter
            />
            <Table.Column
              dataIndex="label"
              key="label"
              title="Label Name"
              render={(value) => <TextField value={value?.name} />}
              sorter
            />
            <Table.Column
              dataIndex="user"
              key="user"
              title="User"
              render={(value) => <TextField value={value?.email} />}
              sorter
            />
            <Table.Column<IRequest>
              title="Actions"
              dataIndex="actions"
              render={(_, record) => (
                <Space>
                  <ShowButton hideText size="small" recordItemId={record._id} />
                  {/* <DeleteButton hideText size='small' recordItemId={record._id} /> */}
                </Space>
              )}
            />
          </Table>
        </Col>
      </Row>
    </List>
  );
};
